export default "__VITE_ASSET__Dv70McrB__"